"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateWeek = void 0;

var tslib_1 = require("tslib");

var date_fns_1 = require("date-fns");

var days = [[2021, 2, 21], [2021, 2, 22], [2021, 2, 23], [2021, 2, 24], [2021, 2, 25], [2021, 2, 26], [2021, 2, 27]];

var generateWeek = function generateWeek(options) {
  if (options === void 0) {
    options = {};
  }

  var week = Array.from({
    length: 7
  }, function (_, i) {
    return {
      label: (0, date_fns_1.format)(new (Date.bind.apply(Date, tslib_1.__spreadArray([void 0], tslib_1.__read(days[i]), false)))(), 'iiii', options),
      display: (0, date_fns_1.format)(new (Date.bind.apply(Date, tslib_1.__spreadArray([void 0], tslib_1.__read(days[i]), false)))(), 'iii', options)
    };
  });
  var weekStartsOn = options.weekStartsOn;

  if (weekStartsOn === 0 || !weekStartsOn) {
    return week;
  }

  return tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(week.slice(weekStartsOn)), false), tslib_1.__read(week.slice(0, weekStartsOn)), false);
};

exports.generateWeek = generateWeek;